import { Group, Text, Tooltip } from '@mantine/core'

import { type TerminologyItem } from './TerminologyContent'

interface TerminologyLabelProps {
  item: TerminologyItem
  required?: boolean
}

export function TerminologyLabel({ item, required }: TerminologyLabelProps) {
  return (
    <Group gap="xs" wrap="nowrap">
      <Tooltip label={item.tooltip} position="right">
        <Text fw={600} size="md">
          {item.label}
          {required && (
            <Text span c="red" inherit>
              *
            </Text>
          )}
        </Text>
      </Tooltip>
    </Group>
  )
}
